import { SupportMessageTags } from '@website/types/graphqlOperations';
import Link from 'next/link';
import { Button } from 'react-bootstrap';
import ContactForm from '../../contactForm/ContactForm';
import { HelpBooking } from '../SelectBooking';

function BookAnotherSpaceContents({ booking }: { booking: HelpBooking }) {
  const { remainingSpaces } = booking.group;

  if (remainingSpaces === 0) {
    return (
      <>
        <h2 className="h4">
          Sorry - there aren't any spaces available currently
        </h2>

        <p>
          We're sorry to say that there are currently no spaces remaining on
          your trip. However, you can add yourself to the wait list on the trip
          page, so that you're notified if more become available.
        </p>
      </>
    );
  }

  const availabilityText =
    remainingSpaces === 1 ? 'is 1 space' : `are ${remainingSpaces} spaces`;

  return (
    <>
      <h2 className="h4">There {availabilityText} available on this trip</h2>

      <p>
        Great news - there {availabilityText} available on your trip still. You
        can book these using the link below (or send this link to a friend).
      </p>

      <p>
        If you need more spaces however, you'll need to add yourself to the wait
        list on the trip page, so that you're notified if more become available.
      </p>
    </>
  );
}

export default function BookAnotherSpace({
  booking,
}: {
  booking: HelpBooking;
}) {
  return (
    <div className="mt-3">
      <BookAnotherSpaceContents booking={booking} />

      {booking.group.remainingSpaces && (
        <Link href={`/book/${booking.group.id}`} legacyBehavior>
          <Button className="me-1 mb-3">Book extra spaces</Button>
        </Link>
      )}

      <Link href={`/trips/${booking.trip.urlSlug}`} legacyBehavior>
        <Button className="me-1 mb-3">Trip page</Button>
      </Link>

      <p>Still need help? Feel free to message us below:</p>

      <ContactForm
        defaultSubject={`Book another space - Booking ${booking.id}`}
        hideTitle
        tags={[SupportMessageTags.BOOK_ANOTHER_SPACE]}
      />
    </div>
  );
}
